// extracted by mini-css-extract-plugin
module.exports = {"wait":"WaitWidget_wait__2GyY8","message":"WaitWidget_message__2czQ6"};